// Hook to handle API requests
import { useState, useCallback } from 'react';

interface UseApiRequestProps {
  onCall?: () => void;
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

interface UseApiRequestReturn {
  call: (request: () => Promise<any>) => Promise<any>;
  isLoading: boolean;
  error: any;
  data: any;
}

export const useRequest = ({ onCall, onSuccess, onError }: UseApiRequestProps): UseApiRequestReturn => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const [data, setData] = useState<any>(null);

  const call = useCallback(async (request: () => Promise<any>) => {
    if (onCall) onCall();
    setIsLoading(true);
    setError(null);
    setData(null);
    try {
      const response = await request();
      setData(response);
      if (onSuccess) onSuccess(response);
      return response;
    } catch (err) {
      setError(err);
      if (onError) onError(err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, [onCall, onSuccess, onError]);

  return { call, isLoading, error, data };
};